/* CVR sticky ATC + gallery progress line - Claude 24-07-26 */
(function () {
  function moveNotifyMe() {
    var bis = document.querySelector('.klaviyo-bis-trigger');
    var form = document.querySelector('product-form.product-form, .product-form');
    if (bis && form && form.parentNode && bis.previousElementSibling !== form) {
      form.parentNode.insertBefore(bis, form.nextSibling);
      return true;
    }
    return false;
  }

  function watchNotifyMe() {
    if (moveNotifyMe()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (moveNotifyMe() || attempts > 20) clearInterval(timer);
    }, 400);
  }

  function initSticky() {
    var submit = document.querySelector('.hm-pdp__atc, [data-atc], .product-form__submit');
    if (!submit) return;

    var bar = document.createElement('div');
    bar.className = 'cvr-sticky-atc';
    bar.innerHTML =
      '<div class="cvr-sticky-atc__info">' +
      '<span class="cvr-sticky-atc__price"></span>' +
      '<span class="cvr-sticky-atc__offer">2 for £49.99 · 4 for £80</span>' +
      '</div>' +
      '<button type="button" class="cvr-sticky-atc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    var priceEl = document.querySelector('.hm-pack.on .hm-pack__price b, .price-item--sale, .price-item--regular, .price-item');
    if (priceEl) {
      bar.querySelector('.cvr-sticky-atc__price').textContent = priceEl.textContent.trim();
    }

    var btn = bar.querySelector('.cvr-sticky-atc__btn');
    if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
      btn.disabled = true;
      btn.textContent = (submit.textContent || 'Sold out').trim();
    }
    btn.addEventListener('click', function () {
      if (submit.disabled) return;
      submit.click();
    });
    // keep sticky label/disabled state in sync with the main ATC (variant changes)
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        btn.disabled = !!submit.disabled;
        btn.textContent = submit.disabled ? (submit.textContent || 'Sold out').trim() : 'Add to cart';
      }).observe(submit, { attributes: true, childList: true, characterData: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { rootMargin: '0px' }
      );
      io.observe(submit);
    } else {
      bar.classList.add('is-visible');
    }
  }

  function initGallery() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var wrapper = document.querySelector('.product__media-wrapper');
    var slider = wrapper && wrapper.querySelector('ul.product__media-list');
    if (!wrapper || !slider) return;
    if (slider.scrollWidth <= slider.clientWidth + 10) return; // single image

    wrapper.classList.add('cvr-gal');

    var track = document.createElement('div');
    track.className = 'cvr-gal__track';
    var thumb = document.createElement('div');
    thumb.className = 'cvr-gal__thumb';
    track.appendChild(thumb);

    function updateProgress() {
      var max = slider.scrollWidth - slider.clientWidth;
      var ratio = max > 0 ? slider.scrollLeft / max : 0;
      var thumbW = Math.max(track.clientWidth * (slider.clientWidth / slider.scrollWidth), 24);
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + ratio * (track.clientWidth - thumbW) + 'px)';
    }
    slider.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);

    wrapper.appendChild(track);
    updateProgress();
  }

  function init() {
    initSticky();
    watchNotifyMe();
    initGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
